import { useEffect, useSyncExternalStore } from 'react'

import type { Platform } from '../../types'

import { getTopBackButtonEntry, subscribeBackButtonStack } from './stack'

type BackButtonHostProps = {
  platform: Platform
}

/** Синхронизирует верх стека <BackButton> с platform.backButton. */
export function BackButtonHost(props: BackButtonHostProps) {
  const { platform } = props
  const topEntry = useSyncExternalStore(subscribeBackButtonStack, getTopBackButtonEntry)

  useEffect(() => {
    if (!topEntry) {
      platform.backButton.hide()
      return
    }

    platform.backButton.show()
    return platform.backButton.onClick(() => topEntry.onPress())
  }, [platform, topEntry])

  return null
}
